import { colors } from '@material-ui/core';
import { SIREN_COLOR } from "config.js";

const white = '#FFFFFF';
const black = '#000000';
const text_label_color = '#1a1a1a';
const regional_color = '#717171';



export default {
  black,
  white,
  text_label_color,
  regional_color,
  primary: {
    contrastText: white,
    dark: colors.indigo[900],
    // main: colors.indigo[500],
    main: '#FF6600', //fiserv 색
    light: colors.indigo[100]
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue['A400'],
    light: colors.blue['A400']
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400]
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400]
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400]
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  background: {
    default: '#F4F6F8',
    paper: white
  },
  // icon: colors.blueGrey[600],
  icon : '#2a3f54',
  divider: colors.grey[200],


  grey: {
    dark: colors.grey[900],
    main: colors.grey[600],
    light: colors.grey[400],
    light2: colors.grey[200],
  },

  siren_symbol: {
    main: SIREN_COLOR.SIREN_SYMBOL_COLOR,
    main2: SIREN_COLOR.SIREN_SYMBOL_COLOR2
  }
};
